import Snap from 'snapsvg';
import {
    resizeFuncCheck,
    resizeFunc,
    resizecheck
} from './_resizecheck';
export var header;
var gNavBtn, globalNav, scrollpos, openLayout;
globalNav = '#globalNav';
gNavBtn = '#gNavBtn';
openLayout = '.openLayout';
export function headerFunc() {
    $(gNavBtn).on('click', function () {
        $(this).find('a').toggleClass('active');
        $(openLayout).toggleClass('open').fadeIn(500);
        if ($(openLayout).hasClass('open')) {
            scrollpos = $(window).scrollTop();
            $(openLayout).fadeIn(500);
            $('body').addClass('fixedBody').css({
                'top': -scrollpos
            });
        } else {
            $('body').removeClass('fixedBody').css({
                'top': 0
            });
            window.scrollTo(0, scrollpos);
            $(openLayout).fadeOut(700);
            $(openLayout).scrollTop(0);
        }
    });
}

export function headerScrollFunc() {
    var scrTop, hLogo, winHeight, hLogoSvg,mainContent;
    hLogo = '#hLogo';
    header = '#header';
    hLogoSvg = '#hLogoSvg';
    mainContent = '#mainContent';
    resizeFuncCheck();
    resizeFunc();
    scrTop = $(document).scrollTop();
    
    //初回読み込み
    if (resizecheck == 1) {
                
        if (scrTop > 0) {
            $(header).addClass('scrollOn');
        } else {
            $(header).removeClass('scrollOn');
        }
    } else {
        if (scrTop > 5) {
            $(header).addClass('scrollOnSp');
        } else {
            $(header).removeClass('scrollOnSp');
        }
    }
    //リサイズ時の処理
    $(window).on('resize', function () {
        resizeFuncCheck();
        resizeFunc();
        scrTop = $(document).scrollTop();
        if (resizecheck == 1) {
            if (scrTop > 0) {
                $(header).addClass('scrollOn');
            } else if (scrTop == 0) {
                $(header).removeClass('scrollOn');
                $(header).removeAttr('style');
            }
        }
    });
    
    //Scroll時の処理
    $(window).on('scroll', function() {
        resizeFuncCheck();
        resizeFunc();
        scrTop = $(document).scrollTop();
        if (resizecheck == 1) {
            if (scrTop > 0) {
                $(header).addClass('scrollOn');
            } else if (scrTop == 0) {
                $(header).removeClass('scrollOn');
            }
        }else{
            if (scrTop > 0) {
                $(header).addClass('scrollOn');
            } else if (scrTop == 0) {
                $(header).removeClass('scrollOn');
            }
        }
    });
}


//////////////////
// WEBPACK FOOTER
// ./src/js/common/_header.js
// module id = 6
// module chunks = 0